import VerifyEmail from "../../../components/Forms/VerifyEmail";
import GeneralLayout from "../../../Layouts/GeneralLayout";
import { changeBrowserTabTitle } from "../../../utils/Browser";

export default function EmailVerifyPage() {
    changeBrowserTabTitle("Verify Email");
    return (
        <>
            <GeneralLayout>
                <VerifyEmail />
            </GeneralLayout>
        </>
    );
}
